import React, { useState } from "react";
import { Link } from "react-router-dom";
import left from "../imgs/left.svg";
import leftsection from "../imgs/left-section.svg";
import googlelogo from "../imgs/googleLogo.svg";
import closedeye from "../imgs/eye-closed.svg";

function Signup() {
  const [eye, setEye] = useState(false);
  const [reEye, setReEye] = useState(false);
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");

  return (
    <div className="flex relative bg-[#f7f9fd]">
      <div className="w-[494px] md:flex lg:flex hidden">
        <img src={leftsection} className="h-[100vh] fixed " />
      </div>
      <div className="py-6 px-8  w-full flex flex-col items-center">
        {/* login nav */}
        <div className="flex w-full justify-between items-center">
          <div className="cursor-not-allowed flex items-center gap-[2px] text-[#4169E1] text-[16px] leading-4 tracking-[2%]">
            <img src={left} alt="" />
            <p className=" font-semibold hover:opacity-90 active:opacity-50">
              Home
            </p>
          </div>
          <Link to={"/login"}>
            <button className="bg-[#4169E1] hover:bg-[#000080] active:opacity-50 rounded-[10px] text-[#F7F9FD] px-[50px] py-[17px]">
              Sign In
            </button>
          </Link>
        </div>
        {/* login nav end*/}

        {/* login section */}
        <div className="mt-8 w-full md:w-[500px] lg:w-[500px]">
          <p className="text-[25px] leading-[44px] font-semibold text-center text-[#4C689E]">
            Sign Up
          </p>
          <div className="mt-[26px] flex flex-col gap-6">
            <div className="bg-white border cursor-not-allowed border-[#D7E1F4] flex justify-center px-[52px] py-[19px] rounded-xl gap-4 shadow">
              <img src={googlelogo} alt="" />
              <p>Signup with Google</p>
            </div>
            <div className="flex items-center gap-[14px]">
              <div className="w-full border-t border-[#A9BADA]"></div>
              <p className="text-[13px] leading-[14.5px] text-[#1B2437] w-[420px]">
                Or create an account
              </p>
              <div className="w-full border-t border-[#A9BADA]"></div>
            </div>
            <div className="bg-[#FFFFFF] rounded-xl border border-[#D7E1F4] px-[42px] py-[40px] text-[16px] text-[#4C689E] leading-[19.36px]">
              <div className="flex gap-4">
                <div className="flex flex-col gap-1">
                  <label>First name</label>
                  <input
                    type="text"
                    className="outline-none p-2 h-[50px] text-[#2B3B5A] border border-[#D7E1F4] rounded-[4px]"
                    placeholder="john"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label>Last name</label>
                  <input
                    type="text"
                    className="outline-none p-2 h-[50px] text-[#2B3B5A] border border-[#D7E1F4] rounded-[4px]"
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <label>Email Address</label>
                <input
                  type="email"
                  className="outline-none p-2 h-[50px] text-[#2B3B5A] border border-[#D7E1F4] rounded-[4px]"
                  placeholder="wabdotmail@gmail.com"
                />
              </div>
              <div className="flex flex-col gap-1 mt-[16px]">
                <label>Password</label>
                {eye ? (
                  <div className=" flex p-2  h-[50px] text-[#2B3B5A] border items-center border-[#D7E1F4] rounded-[4px]">
                    <input
                      type="text"
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="outline-none w-full"
                    />
                    <i
                      class="bi bi-eye text-[24px] text-[#4169E1]"
                      onClick={(e) => setEye(!eye)}
                    ></i>
                  </div>
                ) : (
                  <div className=" flex p-2 h-[50px] text-[#2B3B5A] border border-[#D7E1F4] rounded-[4px]">
                    <input
                      type="password"
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="outline-none w-full"
                    />
                    <img src={closedeye} onClick={(e) => setEye(!eye)} />
                  </div>
                )}
              </div>

              <div className="flex flex-col gap-1 mt-[16px]">
                <label>Re-password</label>
                {eye ? (
                  <div className=" flex p-2  h-[50px] text-[#2B3B5A] border items-center border-[#D7E1F4] rounded-[4px]">
                    <input
                      type="text"
                      placeholder="Enter Password again"
                      value={rePassword}
                      onChange={(e) => setRePassword(e.target.value)}
                      className="outline-none w-full"
                    />
                    <i
                      class="bi bi-eye text-[24px] text-[#4169E1]"
                      onClick={(e) => setReEye(!reEye)}
                    ></i>
                  </div>
                ) : (
                  <div className=" flex p-2 h-[50px] text-[#2B3B5A] border border-[#D7E1F4] rounded-[4px]">
                    <input
                      type="rePassword"
                      placeholder="Enter Password again"
                      value={rePassword}
                      onChange={(e) => setRePassword(e.target.value)}
                      className="outline-none w-full"
                    />
                    <img src={closedeye} onClick={(e) => setReEye(!reEye)} />
                  </div>
                )}
              </div>

              <Link to="/">
                <button className="mt-[30px] w-full text-[#ffffff] h-[50px] bg-[#4169E1] hover:bg-[#000080] active:opacity-50 rounded-[10px]">
                  Register
                </button>
              </Link>
            </div>
          </div>
        </div>
        {/* login section end */}
      </div>
    </div>
  );
}

export default Signup;
